import { PossessorContainer } from '../../containers/advancedFilters/PossessorContainer';
import { IFilter } from '../../types/advancedFilters';

export const possessor: IFilter = {
  component: PossessorContainer,
};
